import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../helpers/fetch.js';

import {
  task_column_options_path,
  task_status_options_path,
} from '~/routes';

export const useTaskOptions = ({ projectId, includePresets = false, includeColumnOptions = true }) => {
  const statusQuery = useQuery({
    queryKey: ['task_status_options'],
    queryFn: () => fetchJson(task_status_options_path()),
    staleTime: 5 * 60 * 1000
  });

  const colQuery = useQuery({
    queryKey: ['task_column_options', projectId],
    queryFn: () => fetchJson(task_column_options_path({ project_id: projectId })),
    enabled: !!projectId && includeColumnOptions,
    staleTime: 5 * 60 * 1000
  });

  const refetch = () => {
    Promise.all([
      statusQuery.refetch(),
      colQuery.refetch()
    ]);
  }

  const task_status_options = statusQuery.data;
  const { sorted_columns, visible_columns } = colQuery.data || {};

  const isLoading = statusQuery.isLoading || colQuery.isLoading;
  const isError = statusQuery.isError || colQuery.isError;
  const error = statusQuery.error || colQuery.error;

  return {
    sorted_columns,
    visible_columns,
    task_status_options,
    isLoading,
    isError,
    error,
    refetch
  };
};
